// 查看会员信息  兑换记录
<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>兑换记录</h3>
            </div>
            <div class="card-button">
              <el-button
                class="push-button"
                icon="iconfont icon-fanhui"
                plain
                @click="NvagetToLookMenber"
                >返回基本信息</el-button
              >
            </div>
          </div>
          <div class="NumberTable">
            <!-- table列表 -->
            <Table
              @TouchTheBottom="TouchTheBottom"
              :PagesData="paging"
              :tableData="list.tbody"
              :configTable="list.thead"
              :config="list"
            ></Table>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetQueryCustCommRedemption } from "@/api/viewMemberModule";
import Table from "/src/components/NumberTable/index.vue";
import { getcpyNo } from "@/utils/auth";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages: 2,
        Loading: true,
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "兑换记录编号",
            prop: "redemptionNo",
            width: 130,
          },
          {
            label: "商品名称",
            prop: "commodityName",
            width: 150,
          },
          {
            label: "类型",
            prop: "commKindText",
            width: 160,
          },
          {
            label: "状态",
            prop: "stateText",
            width: 160,
          },
          {
            label: "商品积分",
            prop: "creditPoint",
            width: 120,
          },
          {
            label: "兑换数量",
            prop: "qty",
            width: 120,
          },
          {
            label: "兑换总积分",
            prop: "exchangeSumPoint",
            width: 120,
          },
          {
            label: "兑换日期",
            prop: "redemptionTime",
            width: 180,
          },
          {
            label: "领取日期",
            prop: "getTime",
            width: 180,
          },
          {
            label: "创建人",
            width: 180,
            prop: "createUserName",
          },
          {
            label: "创建日期",
            prop: "createTimeStr",
            width: 100,
          },
          {
            label: "最后修改人",
            width: 180,
            prop: "updateUserName",
          },
          {
            label: "最后修改日期",
            width: 180,
            prop: "updateTimeStr",
          },
        ],
        tbody: [],
      },
    };
  },
  created() {
    this.RGetQueryCustCommRedemption();
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  methods: {
    ReturnCoupNameText(state) {
      let ReturnCoupNameText = "";
      switch (state) {
        case 0:
          ReturnCoupNameText = "变更与凭证无关";
          break;
        case 1:
          ReturnCoupNameText = "销售";
          break;
        case 2:
          ReturnCoupNameText = "预约";
          break;
        case 3:
          ReturnCoupNameText = "积分兑换";
          break;
      }
      return ReturnCoupNameText;
    },
    ReturnState(state) {
      console.log(state)
      let stateText = "";
      switch (state) {
        case 0:
          stateText = "未领取";
          break;
        case 1:
          stateText = "已领取";
          break;
        case 2:
          stateText = "已废弃";
          break;
      }
      console.log(stateText)
      return stateText;
    },
    RGetQueryCustCommRedemption() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetQueryCustCommRedemption(data).then((res) => {
        if (res.success == true) {
          this.paging.total = res.data.total;
          this.paging.pages = res.data.pages;
          res.data.list.forEach((item, index) => {
            item.CopyIndex =
              (this.paging.page - 1) * this.paging.size + index + 1;
            item.stateText = this.ReturnState(item.state);
            item.commKindText = this.ReturnCoupNameText(parseInt(item.commKind));
            item.redemptionTime = this.renderTime(item.redemptionTime);
            item.getTime = this.renderTime(item.getTime);
            item.updateTime = this.renderTime(item.updateTime);
            item.updateTimeStr = this.renderTime(item.updateTimeStr);
          });
          this.list.tbody = this.list.tbody.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false;
      });
    },
    renderTime(date) {
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    TouchTheBottom() {
      this.paging.page++;
      this.RGetQueryCustCommRedemption();
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  height: 990px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  margin-left: 25px;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
